import React, { useRef, useState } from "react";
import "./FaqAccordion.css";

/* Updated Q&A for Historic Harmon (per Curtis’s notes) */
const ITEMS = [
  {
    q: "What types of spaces are available?",
    a: "The Harmon offers 56 residential loft apartments and three floors of commercial and retail space."
  },
  {
    q: "What documents do I need to apply?",
    a: "A government ID, proof of income, and rental history. A soft credit check or co-signer may be requested."
  },
  {
    q: "How do I schedule a tour?",
    a: "Use the contact form on any page to get in touch with our leasing team, and we’ll help you schedule an in-person or virtual tour."
  },
  {
    q: "Are pets allowed?",
    a: "Yes! Our lofts are pet-friendly, and we only require a modest refundable deposit and monthly pet rent."
  },
  {
    q: "How do I pay rent?",
    a: "Rent is payable via ACH, debit/credit, or autopay. Payments are due the 1st of each month, with reminders sent in advance."
  }
];

/* Chevron icon */
function Chevron({ expanded }) {
  return (
    <svg
      className={`faq-chevron ${expanded ? "is-open" : ""}`}
      viewBox="0 0 24 24"
      width="22"
      height="22"
      aria-hidden="true"
    >
      <path
        d="M6 9l6 6 6-6"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function FaqAccordion({
  title = "FAQ — Living at the Harmon",
  allowMultiple = false
}) {
  const [open, setOpen] = useState(allowMultiple ? new Set() : -1);
  const btnRefs = useRef([]);

  const isOpen = (i) => (allowMultiple ? open.has(i) : open === i);

  const toggle = (i) => {
    if (allowMultiple) {
      setOpen((prev) => {
        const next = new Set(prev);
        next.has(i) ? next.delete(i) : next.add(i);
        return next;
      });
    } else {
      setOpen((prev) => (prev === i ? -1 : i));
    }
  };

  const onKeyDown = (e, i) => {
    const buttons = btnRefs.current.filter(Boolean);
    if (!buttons.length) return;

    if (e.key === "ArrowDown") {
      buttons[(i + 1) % buttons.length].focus();
      e.preventDefault();
    } else if (e.key === "ArrowUp") {
      buttons[(i - 1 + buttons.length) % buttons.length].focus();
      e.preventDefault();
    } else if (e.key === "Home") {
      buttons[0].focus();
      e.preventDefault();
    } else if (e.key === "End") {
      buttons[buttons.length - 1].focus();
      e.preventDefault();
    }
  };

  const pad2 = (n) => String(n).padStart(2, "0");

  return (
    <section className="faq">
      <div className="faq__container">
        <header className="faq__header">
          <h2 className="faq__title">{title}</h2>
          <div className="faq__underline" aria-hidden="true"></div>
        </header>

        <div className="faq__list">
          {ITEMS.map((item, i) => (
            <div className={`faq-item ${isOpen(i) ? "is-open" : ""}`} key={i}>
              <h3 className="faq-item__h">
                <button
                  ref={(el) => (btnRefs.current[i] = el)}
                  className="faq-item__btn"
                  aria-expanded={isOpen(i)}
                  aria-controls={`faq-panel-${i}`}
                  id={`faq-header-${i}`}
                  onClick={() => toggle(i)}
                  onKeyDown={(e) => onKeyDown(e, i)}
                >
                  <span className="faq-item__number">{pad2(i + 1)}</span>
                  <span className="faq-item__question">{item.q}</span>
                  <Chevron expanded={isOpen(i)} />
                </button>
              </h3>

              {/* Smooth height animation using CSS grid trick */}
              <div
                id={`faq-panel-${i}`}
                role="region"
                aria-labelledby={`faq-header-${i}`}
                className="faq-item__panel"
              >
                <div className="faq-item__content">
                  <p>{item.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
